export default __webpack_public_path__ + "static/media/Headphone2.99ba9190.jpg";